import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BaseAsyncValue } from '@ordersnproducts/modules/shared/models/async-value';
import { getOneClickPreloadedOrder } from '../../selectors/one-click-profiles.selector';

export class OneClickQuantityBuilderProvider extends BaseAsyncValue<number> {
  getValue(): Observable<number> {
    return this.store.select(getOneClickPreloadedOrder).pipe(
      map(preloadedOrder => {
        if (
          !!preloadedOrder &&
          !!preloadedOrder.items &&
          !!preloadedOrder.items.length &&
          !!preloadedOrder.items[this.mapItem['index']]
        ) {
          const item = preloadedOrder.items[this.mapItem['index']];
          return item.quantity;
        } else {
          return 0;
        }
      }),
    );
  }
}
